// Функция сортивовки массива аргуметнов Highchart
import _ from 'lodash';


export const chartSortFunc = (a: Array<number>, b: Array<number>) => (a[0] > b[0]) ? 1 : (a[0] < b[0]) ? -1 : 0

export const setMaximizeOptions = (dataSource: any): any => {
  const w = window.innerHeight * 0.9 - 138;
  return {
    ...dataSource,
    chart: {...dataSource.chart, height: w},
    scrollbar: {...dataSource.scrollbar, enabled: true},
    navigator: {...dataSource.navigator, enabled: true},
    pointer: {...dataSource.pointer, chartPosition: undefined},
  }
}


const highChartSettings = {
    lang: {
        rangeSelectorZoom: '',
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        shortMonths: ['Янв', 'Фев', 'Мар', 'Апр', 'Май', 'Июн', 'Июл', 'Авг', 'Сен', 'Окт', 'Ноя', 'Дек'],
        weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        shortWeekdays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        resetZoom: 'Сбросить увеличение',
        noData: 'Отсутствуют данные  \u00a0за последние сутки',
    },

    noData: {
      style: {
        fontFamily: '"Open Sans", Montserrat, "Noto Sans", BlinkMacSystemFont',
        fontWeight: 'bold',
        fontSize: '16px',
        color: '#303030',
        whiteSpace: 'pre-wrap',
        width: 180,
      }
    },

    // Настройки событий печати графика
    printChartEvents: {
      exporting: {
        formAttributes: {
          target: '_blank'
        }
      },
      events: {
        beforePrint: function() {
          let chart: any = this;

          chart.oldhasUserSize = chart.hasUserSize;
          chart.resetParams = [chart.chartWidth, chart.chartHeight, false];
          chart.setSize(1100, 750, false);

          chart.update({
            navigator: {
              enabled: false
            },
            scrollbar: {
              enabled: false
            }
          }, true, false, false);
        },
        afterPrint: function() {
          let chart:any = this;

          chart.setSize.apply(chart, chart.resetParams);
          chart.hasUserSize = chart.oldhasUserSize;

          chart.update({

            navigator: {
              enabled: true
            },
            scrollbar: {
              enabled: true
            }
          }, true, false, true);
        }
      }
    },

    langNodeHistory: function() {
      return {...this.lang, noData: 'Отсутствуют данные  за последние 7 дней'}
    },

    defaultOptions: {
        title: {text: "", useHTML: true},
        navigation: {
          // Отвечает за сокрытие дефолтной кнопки вызова меню "Export options"
          buttonOptions: {
            enabled: false
          }
        },
        chart: {
            height: '250',
            type: 'line',
        },
        credits: {
            enabled: false
        },
        series: [{data: [], dataGrouping: {enabled: false}}],
        scrollbar: {
          enabled: false
        },
        navigator: {
            enabled: false
        },
        rangeSelector: {
            allButtonsEnabled: true,
            inputEnabled: false,
            buttons: [{type: 'minute', count: 5, text: '5 мин'},
                {type: 'minute', count: 30, text: '30 мин'},
                {type: 'hour', count: 1, text: '1 час'},
                {type: 'hour', count: 6, text: '6 час'},
                {type: 'all', text: 'Все'}]
        }
    }
};

export function beforePrint(chart: any, title: string) {

    chart.oldhasUserSize = chart.hasUserSize;
    chart.resetParams = [chart.chartWidth, chart.chartHeight, false];
    chart.setSize(1200, 700, false);

    chart.update({
      navigator: {
        enabled: false
      },
      scrollbar: {
        enabled: false
      }
    }, true, false, false);

    setTimeout(() => {

      chart.setSize.apply(chart, chart.resetParams);
      chart.hasUserSize = chart.oldhasUserSize;

      chart.update({

        navigator: {
          enabled: true
        },
        scrollbar: {
          enabled: true
        }
      }, true, false, true);

    }, 1000);



}

export default highChartSettings;
